interface StateOption {
	value: string;
	label: string;
}

export const brazilianStates: StateOption[] = [
	{ value: 'AC', label: 'Acre' },
	{ value: 'AL', label: 'Alagoas' },
	{ value: 'AP', label: 'Amapá' },
	{ value: 'AM', label: 'Amazonas' },
	{ value: 'BA', label: 'Bahia' },
	{ value: 'CE', label: 'Ceará' },
	{ value: 'DF', label: 'Distrito Federal' },
	{ value: 'ES', label: 'Espírito Santo' },
	{ value: 'GO', label: 'Goiás' },
	{ value: 'MA', label: 'Maranhão' },
	{ value: 'MT', label: 'Mato Grosso' },
	{ value: 'MS', label: 'Mato Grosso do Sul' },
	{ value: 'MG', label: 'Minas Gerais' },
	{ value: 'PA', label: 'Pará' },
	{ value: 'PB', label: 'Paraíba' },
	{ value: 'PR', label: 'Paraná' },
	{ value: 'PE', label: 'Pernambuco' },
	{ value: 'PI', label: 'Piauí' },
	{ value: 'RJ', label: 'Rio de Janeiro' },
	{ value: 'RN', label: 'Rio Grande do Norte' },
	{ value: 'RS', label: 'Rio Grande do Sul' },
	{ value: 'RO', label: 'Rondônia' },
	{ value: 'RR', label: 'Roraima' },
	{ value: 'SC', label: 'Santa Catarina' },
	{ value: 'SP', label: 'São Paulo' },
	{ value: 'SE', label: 'Sergipe' },
	{ value: 'TO', label: 'Tocantins' },
];

export const brazilianStatesAcronym: StateOption[] = [
	{ value: 'AC', label: 'AC' },
	{ value: 'AL', label: 'AL' },
	{ value: 'AP', label: 'AP' },
	{ value: 'AM', label: 'AM' },
	{ value: 'BA', label: 'BA' },
	{ value: 'CE', label: 'CE' },
	{ value: 'DF', label: 'DF' },
	{ value: 'ES', label: 'ES' },
	{ value: 'GO', label: 'GO' },
	{ value: 'MA', label: 'MA' },
	{ value: 'MT', label: 'MT' },
	{ value: 'MS', label: 'MS' },
	{ value: 'MG', label: 'MG' },
	{ value: 'PA', label: 'PA' },
	{ value: 'PB', label: 'PB' },
	{ value: 'PR', label: 'PR' },
	{ value: 'PE', label: 'PE' },
	{ value: 'PI', label: 'PI' },
	{ value: 'RJ', label: 'RJ' },
	{ value: 'RN', label: 'RN' },
	{ value: 'RS', label: 'RS' },
	{ value: 'RO', label: 'RO' },
	{ value: 'RR', label: 'RR' },
	{ value: 'SC', label: 'SC' },
	{ value: 'SP', label: 'SP' },
	{ value: 'SE', label: 'SE' },
	{ value: 'TO', label: 'TO' },
];
